import { React, useState, useEffect, PuffLoader, override, ToastContainer, api, API_URL, toast } from "../../../services/common";
import { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import "./TutorAppointment.css"


const WeeklyCalendar = ({ selectedDate, onDateChange }) => {
    const startOfWeek = dayjs().startOf('week') // Start from Sunday
    const weekDays = [...Array(7)].map((_, i) => startOfWeek.add(i, 'day'));

    return (
        <div className="weekly-calendar">
            {weekDays.map((day, index) => (
                <div
                    key={index}
                    className={`day-tile ${selectedDate.isSame(day, 'day') ? 'selected' : ''}`}
                    onClick={() => onDateChange(day)}
                >
                    <div className="day-label">{day.format('ddd')}</div> {/* Mon, Tue, etc */}
                </div>
            ))}
        </div>
    );
};

const BasicLayout = ({ onFieldChange, onDelete, appointmentData, ...restProps }) => {
    const dateOptions = { day: 'numeric', month: 'long', year: 'numeric' };
    const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Kolkata' };
    const [loading, setLoading] = useState(false);
    const [batch, setBatch] = useState(appointmentData?.batch_limit ? true : false);
    const [batchLimit, setBatchLimit] = useState(appointmentData?.batch_limit)
    const [demo, setDemo] = useState(appointmentData?.demo);
    const [webinar, setWebinar] = useState(appointmentData?.webinar || false);
    const [disabled, setDisabled] = useState(appointmentData?.disabled || false);
    const [selectedDate, setSelectedDate] = useState(dayjs(appointmentData.startDate));
    const [courseNames, setCourseNames] = useState([]);
    const [startTimePicker, setStartTimePicker] = useState(dayjs(appointmentData.startDate));
    const [endTimePicker, setEndTimePicker] = useState(dayjs(appointmentData.endDate));
    const startTime = (new Date(appointmentData.startDate)).toLocaleTimeString('en-IN', timeOptions);
    const endTime = (new Date(appointmentData.endDate)).toLocaleTimeString('en-IN', timeOptions);
    const id = localStorage.getItem('uid');
    const students = appointmentData?.students || [];
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(-1);
    const [slot, setSlot] = useState('');
    const [formData, setFormData] = useState({
        startDate: null,
        endDate: null,
        slot: '',
        course: '',
        demo: false,
        webinar: false,
        disabled: true,
        batch_limit: undefined,
        title: ''
    });

    const handleFieldChange = (field, value) => {
        setFormData(prev => {
            const updatedData = { ...prev, [field]: value };
            onFieldChange(updatedData);
            return updatedData;
        });
    };

    const handleStartTimeChange = (time) => {
        if (!time || !time.isValid()) return;

        const newStart = dayjs(selectedDate)
            .hour(time.hour())
            .minute(time.minute());

        const newEnd = dayjs(endTimePicker)
            .hour(endTimePicker.hour())
            .minute(endTimePicker.minute());

        setStartTimePicker(time);
        setSelectedDate(newStart);

        const slotStr = `${newStart.format('HH:mm')}-${newEnd.format('HH:mm')}`;
        setSlot(slotStr);

        handleFieldChange("startDate", newStart.toDate());
        handleFieldChange("slot", slotStr);
    };

    const handleEndTimeChange = (time) => {
        if (!time || !time.isValid()) return;

        const newStart = dayjs(startTimePicker)
            .hour(startTimePicker.hour())
            .minute(startTimePicker.minute());
        const newEnd = dayjs(selectedDate)
            .hour(time.hour())
            .minute(time.minute());

        setEndTimePicker(time);


        const slotStr = `${newStart.format('HH:mm')}-${newEnd.format('HH:mm')}`;
        setSlot(slotStr);

        handleFieldChange("endDate", newEnd.toDate());
        handleFieldChange("slot", slotStr);
    };
    const demoChange = (event) => {
        const demoValue = event.target.checked
        setDemo(demoValue);
        handleFieldChange("demo", event.target.checked);
    }

    const webinarChange = (event) => {
        const webinarValue = event.target.checked
        setWebinar(webinarValue);
        handleFieldChange("webinar", event.target.checked);
    }

    const disabledChange = (event) => {
        const disabledValue = event.target.checked
        setDisabled(disabledValue);
        handleFieldChange("disabled", event.target.checked);
    }

    const updateCourse = (event) => {
        const index = event.target.value;
        setSelectedCourse(index);
        const course = courses[index].id
        handleFieldChange("course", course);
        handleFieldChange("title", courseNames[course] || '');
    }

    const updateBatchLimit = (event) => {
        const batchNumber = event.target.value;
        setBatchLimit(batchNumber);
        handleFieldChange("batch_limit", event.target.value ? Number(event.target.value) : undefined);
    }

    const batchChange = (event) => {
        setBatch(event.target.checked);
    }


    const onDateChange = (date) => {
        const newStart = dayjs(date)
            .hour(startTimePicker.hour())
            .minute(startTimePicker.minute());
        const newEnd = dayjs(date)
            .hour(endTimePicker.hour())
            .minute(endTimePicker.minute());

        setSelectedDate(newStart);

        const slotStr = `${newStart.format('HH:mm')}-${newEnd.format('HH:mm')}`;
        setSlot(slotStr);

        handleFieldChange("startDate", newStart.toDate());
        handleFieldChange("endDate", newEnd.toDate());
        handleFieldChange("slot", slotStr);
    };

    const getCourses = () => {
        setLoading(true);
        api.get(API_URL + "/tutors/view-tutor/" + id).then((response) => {
            setLoading(false);
            if (response.data.courses) {
                const updatedCourses = response.data.courses;
                setCourses(updatedCourses);
                const courseIdToNameMap = updatedCourses.reduce((acc, course) => {
                    acc[course.id] = course.name; // assuming 'name' is the property for course name
                    return acc;
                }, {});
                setCourseNames(courseIdToNameMap)
                setSelectedCourse(updatedCourses.findIndex(obj => obj.id === appointmentData.course))
                const course = appointmentData.course || updatedCourses[0].id
                const initialObject = {
                    startDate: appointmentData.startDate,
                    endDate: appointmentData.endDate,
                    slot: `${startTime}-${endTime}`,
                    course,
                    title: courseIdToNameMap[course] || ''
                }
                setFormData(initialObject);
                onFieldChange(initialObject);
            }
        })
            .catch((error) => {
                toast.error(error?.response?.data?.message || error.message);;
                setLoading(false);
                console.log(error)
            });
    }

    useEffect(() => {
        setSlot(`${startTime}-${endTime}`);

        getCourses()

    }, []);


    return (
        <>
            <PuffLoader loading={loading} cssOverride={override} color="#7F56D9" />
            <ToastContainer position="bottom-left"
                autoClose={2500} theme="colored" />
            <AppointmentForm.BasicLayout appointmentData={appointmentData} onFieldChange={onFieldChange} {...restProps}>
                <span className="schedule-heading">
                    <span className="mr-1">{appointmentData.title} Class</span>

                    {courses.length === 0 ? (
                        <span> {appointmentData.course}</span>
                    ) : (
                        <span className="course-dropdown">
                            <select
                                id="courseDropdown"
                                value={selectedCourse}
                                onChange={updateCourse}
                            >
                                <option value="" disabled>Select a Course</option>
                                {courses.map((course, index) => (
                                    <option key={course?.id} value={index}>
                                        {course?.name}
                                    </option>
                                ))}
                            </select>
                        </span>
                    )}
                </span>
                <div>
                    <span className="time-slot">{slot}</span>
                </div>
                <WeeklyCalendar selectedDate={selectedDate} onDateChange={onDateChange} />

                <div className="flex time-picker">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['TimePicker']}>
                            <TimePicker
                                className="create-class-label"
                                label="Select Start Time"
                                value={startTimePicker}
                                onChange={handleStartTimeChange}
                            />
                        </DemoContainer>
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['TimePicker']}>
                            <TimePicker
                                className="create-class-label"
                                label="Select End Time"
                                value={endTimePicker}
                                onChange={handleEndTimeChange}
                            />
                        </DemoContainer>
                    </LocalizationProvider>


                 
                  


                    <input type="checkbox" checked={batch} onChange={batchChange} />
                    Batch Limit
                    {batch && <input type="number" min={1} max={10} value={batchLimit} onChange={updateBatchLimit} />}
                    {students.length > 0 && <div className="create-class-label select-students">Students: {students.length}</div>}
                </div>

                <div class="flex m-4 space-between">
                    <div>
                        <input type="checkbox" onChange={demoChange} checked={demo} />
                       <span class="m-1 position-above"> Demo Class</span>
                    </div>

                    <div>
                        <input type="checkbox" onChange={webinarChange} checked={webinar} />
                        <span class="m-1 position-above">Webinar</span>
                    </div>


                    <div >
                        <input type="checkbox" onChange={disabledChange} checked={disabled} />
                        <span class="m-1 position-above">Disable Slot</span>
                    </div>
                </div>
            </AppointmentForm.BasicLayout>
        </>


    );
}

export default BasicLayout;